import React, {useCallback} from "react";
import styles from "./TableManagerHeader.module.css";

import TableControlButton from "./TableControlButton";
import Export from "./export";
import Filter from "./filter";
import ColumnChooser from "./ColumnChooser";
import {useTableManagerContext} from "../TableManagerContext";
import BackButton from "common-ui-components/components/back-button/BackButton";

// importing icons
import searchIcon from "../../icons/search.svg";
import BulkOptions from "./BulkOptions";
import Actions from "./actions/Actions";

const TableManagerHeader = ({headingText, onBackButtonClick, headerProps, filterComponents}) => {
    const {
        setTableControls,
        pagination,
        tableControlsVisibility,
        selectOptions,
        ExtraComponent,
        extraComponentProperties,
        clearSelectedRowsRef,
        searchControlNeeded
    } = useTableManagerContext();

    const {selectedRecords} = selectOptions;

    const handleAction = useCallback(
        ({name, control}) => {
            setTableControls((prevTableControls) => ({
                ...prevTableControls,
                [control]: !prevTableControls[control],
            }));
        },
        [setTableControls]
    );

    const handleClearSelected = () => {
        if (clearSelectedRowsRef?.current?.clearSelected) {
            clearSelectedRowsRef.current.clearSelected();
        }
    };
    const shouldShowExport =
        tableControlsVisibility.exportNeeded && pagination.total > 0;

    const isTableManagerHeaderNeeded =
        tableControlsVisibility.searchNeeded ||
        tableControlsVisibility.printNeeded ||
        shouldShowExport;

    const hideElement = {
        padding: 0,
        margin: 0,
    };

    return (
        <header className={[styles.header, headerProps?.className].join(" ")} style={{...headerProps?.style, ...(isTableManagerHeaderNeeded ? {} : hideElement)}}>
            <div style={{display: "flex", gap: "1rem", justifyContent: "center", alignItems: "center"}}>
                <div>
                    {onBackButtonClick && <BackButton onClick={onBackButtonClick}/>}
                </div>
                <div>
                    {headingText && <h3 className={styles.heading}>{headingText + pagination.total}</h3>}
                </div>
                {selectedRecords.length!==0 && searchControlNeeded &&
                    <div style={{display:"flex",gap:"5px",alignItems:"center",paddingLeft:"1rem",borderLeft:"1px #D2D2D2 solid"}}>
                        <div className={styles.selectionText}>Selected records : {selectedRecords.length}</div>
                        <div onClick={handleClearSelected} variant={"primary"} className={styles.link}> Clear all</div>
                    </div>
                }
                {extraComponentProperties.position === "left" && extraComponentProperties.hideOnNoSelect && selectedRecords.length > 0 &&
                    <div className={styles.extraComponent}>
                        <ExtraComponent selectedRecords={selectedRecords} {...extraComponentProperties} />
                    </div>
                }
                {extraComponentProperties.position === "left" && !(extraComponentProperties.hideOnNoSelect) &&
                    <div className={styles.extraComponent}>
                        <ExtraComponent selectedRecords={selectedRecords} {...extraComponentProperties} />
                    </div>
                }
            </div>

            <div className={styles.panel}>
                <div className={styles.action}>
                    {tableControlsVisibility.searchNeeded && (
                        <TableControlButton
                            name="Search"
                            icon={searchIcon}
                            control="searchable"
                            handleAction={handleAction}
                        />
                    )}
                    {shouldShowExport && <Export handleAction={handleAction}/>}
                    <ColumnChooser handleAction={handleAction}/>
                    <Filter handleAction={handleAction} filterComponents={filterComponents}/>
                    <BulkOptions handleAction={handleAction}/>
                    <Actions/>
                    <div>
                        {extraComponentProperties.position === "right" && extraComponentProperties.hideOnNoSelect && selectedRecords.length > 0 &&
                        <div className={styles.extraComponent}>
                            <ExtraComponent selectedRecords={selectedRecords} {...extraComponentProperties} />
                        </div>
                    }
                    {extraComponentProperties.position === "right" && !(extraComponentProperties.hideOnNoSelect) &&
                        <div className={styles.extraComponent}>
                            <ExtraComponent selectedRecords={selectedRecords} {...extraComponentProperties} />
                        </div>
                    }
                    </div>
                </div>
            </div>
        </header>
    );
};

export default TableManagerHeader;
